<template>
  <div>
    <TextFieldFormatadorDeValor
      v-model="projecao"
      label="Dias de congelamento da projeção"
      style="max-width: 250px;"
      outlined
      hide-details
      class="mt-2"
      suffix="dias"
      @input="aplicarCongelamento()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';

export default {
  components: { TextFieldFormatadorDeValor },
  data: () => ({
    projecao: 0,
    timeout: null
  }),
  computed: {
    ...mapGetters({
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
    })
  },
  methods: {
    aplicarCongelamento() {
      const { id } = this.GET_FORM_NOVO_EVENTO;
      const params = { id: id, projecao: this.projecao }

      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => this.$store.dispatch('EventoSazonalFinal/aplicarCongelamento', params), this.timeout);
    }
  }
}
</script>

<style>

</style>
